export default __webpack_public_path__ + "static/404-ed5a8e1e6d03d43221c77e79ef49e1eb.svg";